module.exports = __webpack_public_path__ + "img/fuzzcv-free.84eba818.png";